import { Sentry } from '@opendoor/observability';
import { configureStore, PreloadedState } from '@reduxjs/toolkit';
import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import createSagaMiddleware from 'redux-saga';

import trackPageView from '../routes/analytics';
import { api } from './api';
// register state event listeners (aka the new sagas)
import './flow_listeners';
import { httpApi } from './httpApi';
import listenerMiddleware from './middleware';
import createReducers from './reducers';
import sagas from './sagas';
import './sellerInput/listeners';

const sagaMiddlewareErrorHandler = (error: Error) => {
  Sentry.withScope((scope) => {
    scope.setTag('source', 'saga');
    Sentry.captureException(error);
  });

  // eslint-disable-next-line no-console
  console.error('Error caught in saga: ', error);
};

// TODO - see why PreloadedState<RootState> cannot be used here..
function initStore(preloadedState?: PreloadedState<any>) {
  const router = routerMiddleware(history);
  const sagaMiddleware = createSagaMiddleware({ onError: sagaMiddlewareErrorHandler });

  trackPageView({
    pathname: history.location.pathname,
    search: history.location.search,
  });
  history.listen((location, _action) => {
    // TODO: we call this in several places, can we consolidate to one?
    trackPageView({ pathname: location.pathname, search: location.search });
  });

  const store = configureStore({
    reducer: createReducers(history),
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredPaths: ['session', 'sellerFlow', 'flow'],
          ignoredActions: ['sellerFlow/didLoadNewPage'],
        },
      }).concat(
        sagaMiddleware,
        api.middleware,
        httpApi.middleware,
        router,
        listenerMiddleware.middleware,
      ),

    preloadedState,
  });
  sagaMiddleware.run(sagas);

  return store;
}

export type RootState = ReturnType<typeof store.getState>;
export type AppStore = typeof store;
export type AppDispatch = typeof store.dispatch;

export const history = createBrowserHistory();
export const store = initStore();
